import { Button } from 'components/ui/button';
import { Loader2, CircleStop } from 'lucide-react';
import { useChatStore } from 'state/store/chat/use-chat-store';
import { useConfig } from 'hooks/use-config';

interface StopGeneratingMessageProps {
    isLoading: boolean;
    isCancelOnGoing?: boolean;
}

export function StopGeneratingMessage({ isLoading, isCancelOnGoing }: StopGeneratingMessageProps) {
    const stopGeneration = useChatStore((state) => state.stopGeneration);
    const activeConversationId = useChatStore((state) => state.activeConversationId);
    const { configurationSettings } = useConfig();

    const handleStopGeneration = async (e: React.MouseEvent) => {
        e.stopPropagation();
        if (activeConversationId && configurationSettings) {
            await stopGeneration(activeConversationId, configurationSettings);
        }
    };

    if (isLoading) {
        return (
            <Button
                variant="outline"
                aria-disabled="false"
                aria-label="Loader"
                className="disabled:opacity-40 flex items-center justify-center h-8 hover:bg-muted rounded-full border w-8"
            >
                <Loader2 size={16} className="animate-spin" />
            </Button>
        );
    }

    return (
        <Button
            variant="outline"
            disabled={isCancelOnGoing}
            aria-disabled="false"
            aria-label="Stop message"
            className="disabled:opacity-40 flex items-center justify-center h-8 hover:bg-muted rounded-full border w-8"
            onClick={handleStopGeneration}
        >
            <CircleStop size={16} />
        </Button>
    );
}
